// extracted by mini-css-extract-plugin
export default {"button-wrapper":"_33pD9","buttonWrapper":"_33pD9","dot":"_3aEKU"};